import styled from 'styled-components';
import { Grid } from '@mantine/core';

const StyledCalendarWrapper = styled(Grid)`
  > div {
    :first-of-type {
      position: relative;
    }

    &.calendar-col-lg {
      @media only screen and (min-width: 64em) {
        flex-basis: 60.333333333333336%;
        max-width: 60.333333333333336%;
      }

      @media only screen and (min-width: 75em) {
        flex-basis: 61.66666666666667%;
        max-width: 61.66666666666667%;
      }
    }

    &.hide-calendar-col-lg {
      @media only screen and (min-width: 64em) {
        flex-basis: 6.333333333333334%;
        max-width: 6.333333333333334%;
      }

      @media only screen and (min-width: 75em) {
        flex-basis: 5%;
        max-width: 5%;
      }

      @media only screen and (max-width: 769px) {
        display: none;
      }
    }
  }

  .met__calendar {
    padding: 0;
    margin-bottom: 5px;
    max-height: 275px;
    transition: all 0.3s ease-in-out;
    opacity: 1;
    overflow: hidden;

    &.hide-met__calendar {
      max-height: 0px;
      opacity: 0;
    }

    @media only screen and (max-width: 1199px) and (min-width: 770px) {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;

      .DayPicker {
        font-size: 1.15rem;
      }
    }

    @media only screen and (max-width: 769px) {
      margin-bottom: 10px;
      padding: 0 !important;

      .DayPicker {
        font-size: 1.15rem;
        display: flex;
        justify-content: center;

        .DayPicker-Month {
          margin: 0 !important;
        }
      }
    }

    @media only screen and (max-width: 500px) {
      .DayPicker {
        font-size: 1.05rem;
      }
    }

    .DayPicker {
      .DayPicker-wrapper {
        padding-bottom: 0;
        outline: 0;

        .DayPicker-NavButton {
          left: auto;
          right: auto;
          color: #212529 !important;
          cursor: pointer;
          user-select: none;
          display: inline-block;
          margin-top: 0;
          width: inherit !important;
          height: inherit !important;
          transition: color 0.15s ease-in-out;
          background-repeat: initial !important;
          background-size: 0 !important;
          background-image: none !important;
          top: 0.2em;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;

          &.DayPicker-NavButton--prev {
            border-right: 12px dashed;
            border-left: 10px solid transparent;
            left: 0.4em;
          }

          &.DayPicker-NavButton--next {
            border-right: 10px solid transparent;
            border-left: 12px dashed;
            right: 0.4em;
          }

          &:focus {
            outline: 0;
          }

          &:hover {
            color: #747474 !important;
          }

          @media only screen and (max-width: 769px) {
            &.DayPicker-NavButton--prev {
              left: 0;
            }

            &.DayPicker-NavButton--next {
              right: 0;
            }
          }

          @media only screen and (max-width: 500px) {
            top: 4.85em;
            opacity: 0.35;
            border-top: 34px solid transparent;
            border-bottom: 34px solid transparent;

            &:hover,
            &:focus {
              opacity: 0.5 !important;
            }

            &.DayPicker-NavButton--prev {
              border-right: 38px dashed;
              border-left: 34px solid transparent;
              left: -5.75rem;
            }

            &.DayPicker-NavButton--next {
              border-right: 34px solid transparent;
              border-left: 38px dashed;
              right: -5.75rem;
            }
          }
        }
      }

      .DayPicker-Caption {
        margin-bottom: 0;
        background-color: #efefef;

        > div {
          font-weight: 600;
          font-size: 1.2em;
          line-height: 1.55;
          color: #212529;
          text-align: center;
        }
      }

      .DayPicker-Month {
        border-collapse: separate;
        margin: 0 0.5em;
      }

      .DayPicker-Weekdays {
        background-color: #efefef;

        > .DayPicker-WeekdaysRow > .DayPicker-Weekday {
          color: #636363;
          padding: 0.25em 0.5em;

          abbr[title] {
            cursor: default;
          }
        }
      }

      .DayPicker-Day {
        font-size: 13px;
        border-width: 1px;
        border-style: solid;
        border-color: #fff;
        border-radius: 0;
        background-color: #fff;
        padding: 0.55em;

        @media only screen and (max-width: 1199px) and (min-width: 501px) {
          font-size: 15px;
        }

        @media only screen and (max-width: 500px) {
          font-size: 14px;
        }

        &.DayPicker-Day--today {
          font-weight: 800;
          color: #000 !important;
        }

        &.DayPicker-Day--hoverRange {
          color: #212529;
          background-color: #f4f4f4 !important;

          &:hover {
            border-color: #d6d6d6;
            background-color: #fff !important;
          }
        }
        &.DayPicker-Day--completeWeek {
          background-color: #d3ffa1;
        }

        &.DayPicker-Day--selected {
          color: #212529;
          background-color: #d1ecf1 !important;

          &:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            color: #212529;
          }

          &:hover {
            border-color: #b9ea87;
            background-color: #fff !important;
          }
        }

        &.DayPicker-Day--outside {
          background-color: #fff !important;
          border-color: #fff !important;
        }

        &:focus {
          outline: 0;
        }
      }
    }
  }
`;

export { StyledCalendarWrapper };
